import { Button, Card, Icon, Intent, Tooltip } from '@blueprintjs/core';
import { formatDate } from '../../../../utils';
import { TimeBlock } from '../../pages/styles';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { WavelightsState } from '../../types';
import { useCallback, useEffect, useState } from 'react';
import { getAllWaveTechniques } from '../../reducer';
import { useNavigate, useParams } from 'react-router-dom';
import { WAVELIGHT_WAVES_TECHNIQUES_ITEM } from '../../routes';
import { Technique } from '../../../../types';
import Table from '../../../../components/Table';
import { usePaginationSearchParams } from '../../../users/components/pagination/hooks';

interface TechniquesTableProps {
  wid: string;
}
const TechniquesTable = ({ wid }: TechniquesTableProps) => {
  const { currentPage, setCurrentPage } = usePaginationSearchParams();
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { techniquesResponse, waveTechniques }: WavelightsState =
    useAppSelector((state) => state.wavelight);

  const [itemsPerPage] = useState(10);

  useEffect(() => {
    if (waveTechniques.length > 0) {
      dispatch(
        getAllWaveTechniques({
          id: wid as string,
          limit: itemsPerPage,
          page: currentPage,
        }),
      );
    }
  }, [dispatch, wid, itemsPerPage, currentPage, waveTechniques]);

  // Move to Technique Screen
  const openTechniqueScreen = useCallback(
    (tid: string) => {
      navigate(WAVELIGHT_WAVES_TECHNIQUES_ITEM(id as string, wid, tid));
    },
    [id, wid, navigate],
  );

  return (
    <Card>
      <Table<Technique>
        rowKey="_id"
        data={techniquesResponse?.techniques || []}
        pagination={{
          currentPage,
          totalPages: techniquesResponse?.totalPages || 0,
          onPageChange: (pageNumber) => setCurrentPage(pageNumber),
        }}
        columns={[
          {
            title: 'ID',
            render: (record) => record._id,
          },
          {
            title: 'Técnica',
            render: (record) => record.technique,
          },
          {
            title: 'Versão',
            render: (record) => record.version,
          },
          {
            title: 'Created',
            render: (record) => formatDate(record.createdAt.toString()),
          },
          {
            title: 'Last Modified',
            render: (record) => formatDate(record.updatedAt.toString()),
          },
          {
            title: 'Computing',
            render: (record) =>
              record.computing ? <Icon icon="time" /> : <Icon icon="tick" />,
          },
          {
            title: 'Duração',
            render: (record) =>
              !record.process_time_taken ? (
                <Icon icon="time" />
              ) : (
                <TimeBlock>
                  <div>
                    <strong>P: </strong>
                    {`${Number(record.process_time_taken / 60).toFixed(2)} min`}
                  </div>
                </TimeBlock>
              ),
          },
          {
            title: 'Ações',
            render: (record) => (
              <Tooltip
                content={<span>Cálculos</span>}
                openOnTargetFocus={false}
                usePortal={false}
              >
                <Button
                  disabled={record.computing}
                  onClick={() => openTechniqueScreen(record._id)}
                  icon={'function'}
                  intent={Intent.PRIMARY}
                />
              </Tooltip>
            ),
          },
        ]}
      />
    </Card>
  );
};

export default TechniquesTable;
